import * as React from "react";
import { classNames } from "react-extras";

interface IProps {
  loading?: boolean;
  className?: string;
  buttonRef?: any; // ref callback, types are hard
  href?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  children: React.ReactNode;
  size?: "xs" | "sm" | "lg" | "xl";
  color?: BootstrapContextColor;
}

interface IState {
  width?: number;
}

class Button extends React.Component<IProps, IState> {
  _button: HTMLButtonElement;
  state: Readonly<IState> = { width: undefined };

  width?: number;

  componentDidMount() {
    if (!this.props.loading) {
      this.setWidth();
    }
  }

  setWidth = () => {
    if (!this.props.loading) {
      const width = this._button.clientWidth;
      this.width = width;
    }
  };

  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    this.setWidth();
  }

  render() {
    const {
      className,
      loading,
      children,
      buttonRef,
      href,
      onClick,
      color = "default",
      size,
      type = "button",
      ...props
    } = this.props;

    const buttonClass = classNames(
      "btn",
      className || `btn-${color}`,
      size ? `btn-${size}` : false
    );

    const click = href ? () => Turbolinks.visit(href) : onClick;

    return (
      <button
        style={{
          minWidth: loading && this.width ? `${this.width}px` : undefined,
        }}
        ref={c => {
          if (c) {
            this._button = c;
            if (buttonRef) buttonRef(c);
          }
        }}
        className={buttonClass}
        onClick={click}
        disabled={loading || props.disabled}
        type={type}
        {...props}
      >
        {loading ? <i className="fa fa-spin fa-gear" /> : children}
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./app/javascript/components/core/Button.tsx